import { ComponentType } from 'react';
import { GameHeader } from './custom-headers';

export const RouteHeaderComponents: Record<string, ComponentType> = {
  '/games/launch/:any/:any?': GameHeader,
  // '/verifyInteracEmail': null,
  // '/shop': ShopHeader,
  // '/register': RegistrationHeader,
};

export const CustomRouteHeaderPaths = Object.keys(RouteHeaderComponents).map(
  (path) => ({ path }),
);

export const DisableBackButtonRoutes = ['/verifyInteracEmail'].map((route) => ({
  path: route,
}));
